import { jsx } from 'react/jsx-runtime';
import { EGDSExpando } from '../../expando/index.esm.js';
const EGDSExpandoListItem = props => {
  const {
    triggerPosition = 'leading',
    ...otherProps
  } = props;
  return jsx(EGDSExpando, {
    ...otherProps,
    triggerPosition: triggerPosition,
    type: "list"
  });
};
EGDSExpandoListItem.displayName = 'EGDSExpandoListItem';
export { EGDSExpandoListItem };